import * as URL from "../../helpers/Constants";
import axios from "axios";

const mockDoctor = {
    nameBn: "প্রফেসর ড. আনামুল করিম",
    credentialsBn: "এমবিবিএস, এফসিপিএস, এফএসিপি",
    positionBn: "প্রফেসর ও মেডিসিন বিভাগের প্রধান",
    institutionBn: "ঢাকা মেডিকেল কলেজ ও হাসপাতাল, ঢাকা",
    nameEn: "Prof. Dr. Anamul Karim",
    credentialsEn: "MBBS, FCPS, FACP",
    positionEn: "Professor & Head of Dept. of Medicine",
    institutionEn: "Dhaka Medical College & Hospital, Dhaka",
    footerLogoUrl: null,
    footerText: "চেম্বার: ইবনে সিনা ডায়াগনস্টিক এন্ড ইমেজিং সেন্টার, বাড়ি নং- ৪৮, রোড নং- ৭/এ, সাতমসজিদ রোড, ধানমন্ডি, ঢাকা-১২০৯ | সিরিয়ালের জন্য হটলাইন : ১০৬১০, ০৯৪৩০০৩০৬১৫, ফোন : ৫৮১৫৩৭০-১, ৮৮১৪৮০৮০-১, Web : www.ibnsinatrust.com\nসাক্ষাতের সময়: রবি, সোম ও বুধবার সকাল ১০টা - দুপুর ১টা পর্যন্ত।",
};

const mockPrescriptions = [
    {
        id: 4, patientId: 1,
        visitingDate: "2025-08-03T16:35:00",
        lastModifiedDate: "2025-08-03T16:35:00", lastModifiedBy: "Abid Shinepuk",
        notes: "",
        doctor: mockDoctor,
        patient: {name: "Anamul", age: "12 Years", gender: "Male"},
        complaints: [{name: "Fever", duration: "7 days"}, {name: "Weakness", duration: "3 days"}],
        medicines: [
            {name: "Tab. Napa", strength: "10 mg", generic: "Paracetamol", dosage: "১+০+০", timing: "খাবারের পরে", duration: "চলবে"},
            {name: "Tab. Napa", strength: "10 mg", generic: "Paracetamol", dosage: "১+০+০", timing: "খাবারের পরে", duration: "চলবে"},
            {name: "Tab. Napa", strength: "10 mg", generic: "Paracetamol", dosage: "১+০+০", timing: "খাবারের পরে", duration: "চলবে"},
        ],
        pastHistory: [{name: "Hypertension", duration: "12 years"}],
        examination: [
            {name: "Temperature", value: "102 F"},
            {name: "Blood Pressure", value: "100/70 mm hg"},
            {name: "Weight", value: "67 kg"},
        ],
        investigations: ["CBC", "Blood Sugar", "Vitamin D"],
        advices: "Don't use any oil or soap.",
        followUp: "After 7 days",
    },
    {id: 3, patientId: 1, visitingDate: "2025-08-03T16:35:00", lastModifiedDate: "2025-08-03T16:35:00", lastModifiedBy: "Abid Shinepuk", notes: "", doctor: mockDoctor, patient: {name: "Anamul", age: "12 Years", gender: "Male"}, complaints: [], medicines: [], pastHistory: [], examination: [], investigations: [], advices: "", followUp: ""},
    {id: 2, patientId: 1, visitingDate: "2025-08-03T16:35:00", lastModifiedDate: "2025-08-03T16:35:00", lastModifiedBy: "Abid Shinepuk", notes: "", doctor: mockDoctor, patient: {name: "Anamul", age: "12 Years", gender: "Male"}, complaints: [], medicines: [], pastHistory: [], examination: [], investigations: [], advices: "", followUp: ""},
    {id: 1, patientId: 1, visitingDate: "2025-08-03T16:34:00", lastModifiedDate: "2025-08-03T16:35:00", lastModifiedBy: "Abid Shinepuk", notes: "", doctor: mockDoctor, patient: {name: "Anamul", age: "12 Years", gender: "Male"}, complaints: [], medicines: [], pastHistory: [], examination: [], investigations: [], advices: "", followUp: ""},
];

export default class PMSPatientPrescriptionServices {

    static getAllPrescriptionsByPatientId(patientId, params) {
        // return axios.get(`${URL.PMS_GET_ALL_PRESCRIPTIONS_BY_PATIENT_ID}/${patientId}`, {
        //     ...PMSPatientPrescriptionServices.getAuthHeader(),
        //     params,
        // });
        const {page = 0, size = 10, searchKey = ''} = params || {};
        const filtered = mockPrescriptions.filter(p => p.patientId === Number(patientId));
        const start = page * size;
        return Promise.resolve({
            data: {
                content: filtered.slice(start, start + size),
                totalElements: filtered.length,
            },
        });
    }

    static getPrescriptionById(patientId, id) {
        // return axios.get(`${URL.PMS_GET_PRESCRIPTION_BY_PATIENT_ID_BY_ID}/${patientId}/${id}`, PMSPatientPrescriptionServices.getAuthHeader());
        const prescription = mockPrescriptions.find(p => p.id === Number(id)) || null;
        return Promise.resolve({data: prescription});
    }

    static createPrescription(patientId, data) {
        // return axios.post(`${URL.PMS_CREATE_PRESCRIPTION_BY_PATIENT_ID}/${patientId}`, data, PMSPatientPrescriptionServices.getAuthHeader());
        const newPrescription = {id: Date.now(), patientId: Number(patientId), ...data, lastModifiedDate: new Date().toISOString()};
        mockPrescriptions.unshift(newPrescription);
        return Promise.resolve({data: newPrescription});
    }

    static updatePrescriptionById(id, data) {
        // return axios.put(`${URL.PMS_UPDATE_PRESCRIPTION_BY_ID}/${id}`, data, PMSPatientPrescriptionServices.getAuthHeader());
        const idx = mockPrescriptions.findIndex(p => p.id === Number(id));
        if (idx !== -1) mockPrescriptions[idx] = {...mockPrescriptions[idx], ...data, lastModifiedDate: new Date().toISOString()};
        return Promise.resolve({data: mockPrescriptions[idx]});
    }

    static deletePrescriptionById(id) {
        // return axios.delete(`${URL.PMS_DELETE_PRESCRIPTION_BY_ID}/${id}`, PMSPatientPrescriptionServices.getAuthHeader());
        const idx = mockPrescriptions.findIndex(p => p.id === Number(id));
        if (idx !== -1) mockPrescriptions.splice(idx, 1);
        return Promise.resolve({data: {success: true}});
    }

    static getAuthHeader() {
        return {headers: {Authorization: `Bearer ${localStorage.getItem("oushodsheba_access_token")}`}};
    }
}
